export default "__VITE_ASSET__BkZGu2wy__"